import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {ITroubleShootData} from "../reducers/troubleshoot.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getTroubleShootDataState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.troubleShootData);

export const getTroubleShootData = (websiteId: number) => createSelector(getTroubleShootDataState,
  (state: ITroubleShootData): any => state.entities[websiteId] && state.entities[websiteId].data ? state.entities[websiteId].data : null
);

export const getTroubleShootDataLoaded = (websiteId: number) => createSelector(getTroubleShootDataState,
  (state: ITroubleShootData): any => state.entities[websiteId] && state.entities[websiteId].loaded ? state.entities[websiteId].loaded : true
);

export const getTroubleShootDataLoading = (websiteId: number) => createSelector(getTroubleShootDataState,
  (state: ITroubleShootData): any => state.entities[websiteId] && state.entities[websiteId].loading
    ? state.entities[websiteId].loading : null
);
